module.exports = __webpack_public_path__ + "static/nyancat-44e7fedbf298fdcfa87cf2eeaa49e983.gif";